/*
 * @name: name
 * 
 * @Author: 黄晓玲
 * @Date: 2022-11-27 10:03:56
 * @LastEditors: 黄晓玲
 * @LastEditTime: 2022-12-02 16:20:23
 * @Description: 描述
 */
import * as apiCommon from '@/api/apiCommon'

// 关于我们
const apiName = '/webapi/article'

// 获取菜单栏目
export function getChildCategory(data) {
	return apiCommon.index(apiName + '/child_category', data)
}

//初始化年份
export function getYears(data) {
	return apiCommon.index(apiName + '/get_years', data)
}

//获取栏目数据
export function getIndex(data) {
	return apiCommon.index(apiName + '/index', data)
}

//详情
export function read(data) {
  return apiCommon.index(apiName + '/read', data);
}

//发展历程
export function getYearChildData(data) {
  return apiCommon.index(apiName + '/getYearChildData', data);
}